import { PwaService } from './core/pwa/pwa.service';
import { MaintenanceService } from './core/http/maintenance.service';
import { PwaControlsComponent } from './core/pwa/pwa-controls.component';
import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { GameService } from './core/state/game.service';
import { IconComponent } from './shared/ui/icon/icon.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    PwaControlsComponent,
    CommonModule,
    RouterOutlet,
    IconComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  readonly maintenance = inject(MaintenanceService);
  readonly pwa = inject(PwaService);
  readonly game = inject(GameService);
}
